// import { AttributesUtil } from '../attributes/attributes.util';
// import { ErrorCdsEnums } from 'src/app/shared/errorcds.enums';
// import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';
// import { Tgt_Attr_Lnk } from 'src/app/shared/models/domain/tgt_attr_lnk';
// import { TargetWrapper } from '../../../modules/design/transforms/target/target.wrapper';
// import { CommonEnums } from 'src/app/shared/common.enums';
// import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';

// export class Tgt_Attr_LnkTabulator {
//     private static instance: Tgt_Attr_LnkTabulator;

//     static getInstance() {
//         if (!Tgt_Attr_LnkTabulator.instance) {
//             Tgt_Attr_LnkTabulator.instance = new Tgt_Attr_LnkTabulator();
//         }

//         return Tgt_Attr_LnkTabulator.instance;
//     }

//     /**
//     * Tgt_Attr_LnkColumns is a singleton class, so use Tgt_Attr_LnkColumns.getInstance() method instead of creating new Tgt_Attr_LnkColumns().
//     */
//     private constructor() {
//     }

//     getTgt_dObj_Inst_Attr_Id(targetWrapper: TargetWrapper): any {
//         let column: any = {};

//         column.title = "Target Attribute";
//         column.field = 'tgt_dObj_Inst_Attr_Id';
//         column.width = 200;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

//             let attributeObj: any = targetWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id);
//             if (!attributeObj) return '';

//             return attributeObj.attrNm;
//         }

//         return column;
//     }

//     getTgtDTypNm(targetWrapper: TargetWrapper): any {
//         let column: any = {};

//         column.title = "Tgt Data Type";
//         column.field = 'tgtDTypNm';
//         column.width = 150;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

//             let attributeObj: any = targetWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id);
//             if (!attributeObj) return '';

//             return AttributesUtil.getInstance().getAttributeType(targetWrapper.dbTyp_Id, attributeObj);
//         }

//         return column;
//     }

//     getSrcAttrNm(targetWrapper: TargetWrapper): any {
//         let tgt_Attr_LnkTabulator = this;

//         let column: any = {};
//         column.title = "Source Attribute";
//         column.field = 'srcAttrNm';
//         column.width = 250;
//         column.headerSort = false;

//         column.formatter = function getValue(cell) {
//             let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();
//             if (tgt_Attr_Lnk.lnk_Obj_Id == -1 &&
//                 tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//                 return '';
//             }

//             let attributeObj: any = targetWrapper.carryForwardAttributesHMapIds.get(tgt_Attr_Lnk.lnk_Obj_Id + '-' + tgt_Attr_Lnk.lnk_Obj_Attr_Id);
//             if (!attributeObj) return "";

//             return attributeObj.attrFullNm;
//         }
//         if (targetWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

//         column.editor = function (cell, onRendered, success, cancel, editorParams) {
//             let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

//             let editor: any;
//             editor = document.createElement("select");
//             editor.id = "mySelect";

//             if (targetWrapper.carryForwardGroupAttributes.length > 0) {
//                 let obj_Nm: string = '';
//                 for (let i: number = 0; i < targetWrapper.carryForwardGroupAttributes.length; i++) {
//                     let option: any = document.createElement("option");

//                     if (obj_Nm != targetWrapper.carryForwardGroupAttributes[i].obj_Nm) {
//                         obj_Nm = targetWrapper.carryForwardGroupAttributes[i].obj_Nm;

//                         option.value = targetWrapper.carryForwardGroupAttributes[i].obj_Nm;
//                         option.text = targetWrapper.carryForwardGroupAttributes[i].obj_Nm;
//                         editor.appendChild(option);
//                     }

//                     option.value = targetWrapper.carryForwardGroupAttributes[i].obj_Id + '-' + targetWrapper.carryForwardGroupAttributes[i].attr_Id;
//                     option.text = targetWrapper.carryForwardGroupAttributes[i].name;

//                     editor.appendChild(option);
//                 }
//             }

//             editor.value = tgt_Attr_Lnk.lnk_Obj_Id + "-" + tgt_Attr_Lnk.lnk_Obj_Attr_Id; //cell.getValue();

//             editor.style.width = "100%";
//             editor.style.boxSizing = "border-box";

//             onRendered(function () {
//                 editor.focus();
//             });

//             let oldValue: string = tgt_Attr_Lnk.lnk_Obj_Id + "-" + tgt_Attr_Lnk.lnk_Obj_Attr_Id;
//             function successFunc() {
//                 if (editor.value == "") {
//                     success(editor.value);
//                     return;
//                 }

//                 if (editor.value == oldValue) {
//                     success(editor.value);
//                     return;
//                 }

//                 let obj_Attr_Ids: Array<any> = editor.value.split('-');

//                 tgt_Attr_Lnk.lnk_Obj_Id = parseInt(obj_Attr_Ids[0]);
//                 tgt_Attr_Lnk.lnk_Obj_Attr_Id = parseInt(obj_Attr_Ids[1]);

//                 for (let i: number = 0; i < targetWrapper.carryForwardGroupAttributes.length; i++) {
//                     let carryForwardGroupAttribute: any = targetWrapper.carryForwardGroupAttributes[i];
//                     if (carryForwardGroupAttribute.obj_Id == tgt_Attr_Lnk.lnk_Obj_Id &&
//                         carryForwardGroupAttribute.attr_Id == tgt_Attr_Lnk.lnk_Obj_Attr_Id) {
//                         tgt_Attr_Lnk.valid_Cd = tgt_Attr_LnkTabulator.verifyFamily(tgt_Attr_Lnk, carryForwardGroupAttribute, targetWrapper) ? "0" : "-1";

//                         break;
//                     }
//                 }

//                 targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//                 tgt_Attr_Lnk.currIndFlag = CommonEnums.flag.NO;
//                 tgt_Attr_Lnk.surrogate_Key = CommonEnums.flag.NO;

//                 targetWrapper.doValidate();

//                 setTimeout(() => {
//                     cell.getRow().reformat();
//                 });

//                 success(editor.value);
//             }

//             editor.addEventListener("change", successFunc);
//             editor.addEventListener("blur", successFunc);
//             return editor;
//         }

//         return column;
//     }

//     getSrcDTypNm(targetWrapper: TargetWrapper): any {
//         let column: any = {};
//         column.title = "Src Data Type";
//         column.field = "srcDTypNm";
//         column.width = 150;
//         column.headerSort = false;

//         column.formatter = function getValue(cell) {
//             let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

//             if (tgt_Attr_Lnk.lnk_Obj_Id == -1 &&
//                 tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//                 return '';
//             }

//             let attributeObj: any = targetWrapper.carryForwardAttributesHMapIds.get(tgt_Attr_Lnk.lnk_Obj_Id + '-' + tgt_Attr_Lnk.lnk_Obj_Attr_Id);
//             if (!attributeObj) return "";

//             return attributeObj.attrDTypNm;
//         }

//         return column;
//     }

//     getValid_Cd(targetWrapper: TargetWrapper): any {
//         let column: any = {};
//         column.title = "!";
//         column.field = 'valid_Cd';
//         column.width = 20;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             if (cell.getValue() == "0") {
//                 return '';
//             }

//             return "<i " + ErrorCdsEnums.errorcds[cell.getValue()] + "' class='text-warning fs-9 fa fa-circle hand'></i>";
//         }

//         return column;
//     }

//     getOrderBy(targetWrapper: TargetWrapper): any {
//         let orderByColumn = this;

//         let column: any = {};
//         column.field = "orderBy";
//         column.title = "Order";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function getValue(cell) {
//             let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();
//             if (tgt_Attr_Lnk.orderBy == 0) return "";

//             return tgt_Attr_Lnk.orderBy;
//         };
//         if (targetWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

//         column.editor = function (cell, onRendered, success, cancel, editorParams) {
//             let value = cell.getValue();
//             this.dropdownlist = orderByColumn.getAttributesLengthList((targetWrapper as TargetWrapper).target.tgt_Attr_Lnks);

//             let editor;
//             if (this.dropdownlist.length > 0) {
//                 editor = document.createElement("select");
//                 editor.id = "mySelect";

//                 for (let i: number = 0; i < this.dropdownlist.length; i++) {
//                     let option = document.createElement("option");
//                     option.value = this.dropdownlist[i].value;
//                     option.text = this.dropdownlist[i].value;
//                     editor.appendChild(option);
//                 }

//                 editor.value = value;
//             }

//             editor.style.width = "100%";
//             editor.style.boxSizing = "border-box";

//             onRendered(function () {
//                 editor.focus();
//             });

//             function successFunc() {
//                 editor.value = value;
//                 targetWrapper.doValidate();

//                 success(editor.value);
//             }

//             editor.addEventListener("change", successFunc);
//             editor.addEventListener("blur", successFunc);

//             return editor;
//         }

//         return column;
//     }

//     getUpdKeyFlag(targetWrapper: TargetWrapper): any {
//         let updKeyFlagComponet = this;

//         let column: any = {};
//         column.field = "updKeyFlag";
//         column.title = "Unique";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem: any = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "updKeyFlag" + dataItem.tgt_dObj_Inst_Attr_Id;
//             editor.checked = dataItem.updKeyFlag == 'Y' ? true : false;

//             editor.onclick = function (event: any) {
//                 dataItem.updKeyFlag = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;

//                 let rows: Array<any> = cell.getTable().getRows();
//                 if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//                     dataItem.scdFlag = 'N';
//                     dataItem.currIndFlag = 'N'
//                     dataItem.scdStartDtFlag = 'N'
//                     dataItem.scdEndDtFlag = 'N'
//                     dataItem.surrogate_Key = 'N'
//                 }

//                 if (targetWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE &&
//                     targetWrapper.target.tgt_Inst.tgtLoadType == 'UPI') {
//                     for (let i: number = 0; i < rows.length; i++) {
//                         let tgt_attr_lnkTmp: Tgt_Attr_Lnk = rows[i]._row.data;
//                         if (tgt_attr_lnkTmp.tgt_dObj_Inst_Attr_Id == dataItem.tgt_dObj_Inst_Attr_Id) continue;

//                         if (tgt_attr_lnkTmp.updKeyFlag == CommonEnums.flag.YES) {
//                             tgt_attr_lnkTmp.updKeyFlag = CommonEnums.flag.NO;
//                             targetWrapper.validateTgt_Attr_Lnk(tgt_attr_lnkTmp);
//                             rows[i].reformat();
//                         }
//                     }
//                 }

//                 dataItem.update_Column = 'N';
//                 targetWrapper.validateTgt_Attr_Lnk(dataItem);
//                 targetWrapper.doValidate();
//                 cell.getRow().reformat();
//             }
//             //disable functionlaity TODO
//             if (updKeyFlagComponet.isUniKeyDisabled(targetWrapper, dataItem)) {
//                 editor.setAttribute("disabled", "true");
//             }
//             return editor;
//         }

//         return column;
//     }

//     getScdFlag(targetWrapper: TargetWrapper): any {
//         let scdFlagCompent = this;

//         let column: any = {};
//         column.field = "scdFlag";
//         column.title = "SCD key";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem: any = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "scdFlag" + dataItem.scdFlag;
//             editor.checked = dataItem.scdFlag == 'Y' ? true : false;
//             editor.onclick = function (event: any) {
//                 dataItem.scdFlag = event.target.checked ? 'Y' : 'N';
//                 dataItem.updKeyFlag = 'N';
//                 dataItem.scdStartDtFlag = 'N';
//                 dataItem.scdEndDtFlag = 'N';
//                 dataItem.currIndFlag = 'N'
//                 dataItem.surrogate_Key = 'N'

//                 if (dataItem.lnk_Obj_Attr_Id == -1) {
//                     dataItem.scdFlag = "N";
//                 }
//                 cell.getRow().reformat();
//                 targetWrapper.validateTgt_Attr_Lnk(dataItem);
//                 targetWrapper.doValidate();

//             }
//             //disable functionlaity
//             if (scdFlagCompent.isScdFlagDisabled(targetWrapper, dataItem)) {
//                 editor.setAttribute("disabled", "true");
//             }
//             return editor;
//         }

//         return column;
//     }

//     getHashKey(targetWrapper: TargetWrapper): any {
//         let hashFlagComponent = this;

//         let column: any = {};
//         column.field = "hashKey";
//         column.title = "Hash key";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem: any = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "hashKey" + dataItem.hashKey;
//             editor.checked = dataItem.scdFlag == 'Y' ? true : false;
//             editor.onclick = function (event: any) {
//                 dataItem.hashKey = event.target.checked ? 'Y' : 'N';
//                 hashFlagComponent.hashKeyChanged(dataItem, targetWrapper)
//             }
//             //disable functionlaity
//             if (hashFlagComponent.isHashKeyFlagDisabled(targetWrapper, dataItem)) {
//                 editor.setAttribute("disabled", "true");
//             }

//             return editor;
//         }

//         return column;
//     }

//     getScdStartDtFlag(targetWrapper: TargetWrapper): any {
//         let scdStartDtFlagComponent = this;

//         let column: any = {};
//         column.field = "scdStartDtFlag";
//         column.title = "SCD Start";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem: any = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "scdStartDtFlag" + dataItem.scdStartDtFlag;
//             editor.checked = dataItem.scdStartDtFlag == 'Y' ? true : false;
//             let rows: Array<any> = cell.getTable().getRows();

//             editor.onclick = function (event: any) {
//                 dataItem.scdStartDtFlag = event.target.checked ? 'Y' : 'N';
//                 // scdStartDtFlagComponent.scdStartDtFlagChanged(dataItem, targetWrapper)

//                 if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//                     dataItem.updKeyFlag = 'N';
//                     dataItem.scdFlag = 'N';
//                     dataItem.scdEndDtFlag = 'N';
//                     dataItem.currIndFlag = 'N';
//                     dataItem.surrogate_Key = 'N';
//                 }

//                 for (let i = 0; i < rows.length; i++) {
//                     let tgt_Attr_LnkTmp = rows[i]._row.data;
//                     if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == dataItem.tgt_dObj_Inst_Attr_Id) continue;

//                     if (tgt_Attr_LnkTmp.scdStartDtFlag != 'N') {
//                         tgt_Attr_LnkTmp.scdStartDtFlag = 'N';
//                         rows[i].reformat();
//                         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
//                     }
//                 }
//                 cell.getRow().reformat();
//                 targetWrapper.validateTgt_Attr_Lnk(dataItem);
//                 targetWrapper.doValidate();

//             }
//             //disable functionlaity TO DO
//             if (scdStartDtFlagComponent.isScdDtDisabled(targetWrapper, dataItem, true)) {
//                 editor.setAttribute("disabled", "true");
//             }

//             return editor;
//         }

//         return column;
//     }

//     getScdEndDtFlag(targetWrapper: TargetWrapper): any {
//         let scdEndcomponent = this;

//         let column: any = {};
//         column.field = "scdEndDtFlag";
//         column.title = "SCD End";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "scdEndDtFlag" + dataItem.scdEndDtFlag;
//             editor.checked = dataItem.scdEndDtFlag == 'Y' ? true : false;
//             editor.onclick = function (event: any) {
//                 dataItem.scdEndDtFlag = event.target.checked ? 'Y' : 'N';
//                 //scdEndcomponent.scdEndDtFlagChanged(dataItem, targetWrapper)
//                 let rows: Array<any> = cell.getTable().getRows();
//                 if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//                     dataItem.updKeyFlag = 'N';
//                     dataItem.scdFlag = 'N';
//                     dataItem.scdStartDtFlag = 'N';
//                     dataItem.currIndFlag = 'N';
//                     dataItem.surrogate_Key = 'N';
//                 }
//                 for (let i = 0; i < rows.length; i++) {
//                     let tgt_Attr_LnkTmp = rows[i]._row.data;
//                     if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == dataItem.tgt_dObj_Inst_Attr_Id) continue;

//                     if (tgt_Attr_LnkTmp.scdEndDtFlag != 'N') {
//                         tgt_Attr_LnkTmp.scdEndDtFlag = 'N';
//                         rows[i].reformat();
//                         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
//                     }
//                 }
//                 cell.getRow().reformat();
//                 targetWrapper.validateTgt_Attr_Lnk(dataItem);
//                 targetWrapper.doValidate();

//             }

//             if (scdEndcomponent.isScdDtDisabled(targetWrapper, dataItem, false)) {
//                 editor.setAttribute("disabled", "true");
//             }

//             return editor;
//         }

//         return column;
//     }

//     getCurrIndFlag(targetWrapper: TargetWrapper): any {
//         let currIndFlagComponnet = this;

//         let column: any = {};
//         column.field = "currIndFlag";
//         column.title = "Current Ind";
//         column.width = 100;
//         column.sortable = false;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "currIndFlag" + dataItem.currIndFlag;
//             editor.checked = dataItem.currIndFlag == 'Y' ? true : false;
//             editor.onclick = function (event: any) {
//                 dataItem.currIndFlag = event.target.checked ? 'Y' : 'N';
//                 currIndFlagComponnet.currIndFlagChanged(dataItem, targetWrapper);
//                 cell.getRow().reformat();
//             }
//             //disable functionlaity TO DO
//             if (currIndFlagComponnet.isCurrIndDisabled(targetWrapper, dataItem)) {
//                 editor.setAttribute("disabled", "true");
//             }

//             return editor;
//         }

//         return column;
//     }

//     getSurrogate_Key(targetWrapper: TargetWrapper): any {
//         let surrogate_KeyComponent = this;

//         let column: any = {};
//         column.field = "surrogate_Key";
//         column.title = "Surrogate Key.";
//         column.width = 100;
//         column.sortable = false;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem: any = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "surrogate_Key" + dataItem.surrogate_Key;
//             editor.checked = dataItem.surrogate_Key == 'Y' ? true : false;
//             editor.onclick = function (event: any) {
//                 dataItem.surrogate_Key = event.target.checked ? 'Y' : 'N';
//                 surrogate_KeyComponent.surrogate_KeyChanged(dataItem, targetWrapper)
//             }
//             //disable functionlaity TO DO
//             if (surrogate_KeyComponent.isSurrKeyDisabled(targetWrapper, dataItem)) {
//                 editor.setAttribute("disabled", "true");
//             }

//             return editor;
//         }

//         return column;
//     }

//     getInsert_Column(targetWrapper: TargetWrapper): any {
//         let insert_ColumnComponnet = this;

//         let column: any = {};
//         column.field = "insert_Column";
//         column.title = "Insert";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "insert_Column" + dataItem.insert_Column;
//             editor.checked = dataItem.insert_Column == 'Y' ? true : false;
//             editor.onclick = function (event: any) {
//                 dataItem.insert_Column = event.target.checked ? 'Y' : 'N';
//                 insert_ColumnComponnet.insert_ColumnChanged(dataItem, targetWrapper);
//             }
//             //disable functionlaity TO DO
//             if (insert_ColumnComponnet.isUniKeyDisabled(targetWrapper, dataItem)) {
//                 editor.setAttribute("disabled", "true");
//             }

//             return editor;
//         }

//         return column;
//     }

//     getUpdate_Column(targetWrapper: TargetWrapper): any {
//         let update_ColumnComponnet = this;

//         let column: any = {};
//         column.field = "update_Column";
//         column.title = "Update";
//         column.width = 100;
//         column.headerSort = false;

//         column.formatter = function (cell, formatterParams, onRendered) {
//             let dataItem = cell.getData();
//             let editor = document.createElement('input');
//             editor.type = "checkbox";
//             editor.id = "update_Column" + dataItem.update_Column;
//             editor.checked = dataItem.update_Column == 'Y' ? true : false;
//             editor.onclick = function (event: any) {
//                 dataItem.update_Column = event.target.checked ? 'Y' : 'N';
//                 update_ColumnComponnet.update_ColumnChanged(dataItem, targetWrapper);
//                 cell.getRow().reformat();
//             }
//             if (update_ColumnComponnet.isUniKeyDisabled(targetWrapper, dataItem)) {
//                 editor.setAttribute("disabled", "true");
//             }

//             return editor;
//         }

//         return column;
//     }

//     getAttributesLengthList(attributes: Array<any>): Array<any> {
//         let list: Array<any> = new Array<any>();

//         for (let i = 0; i <= attributes.length; i++) {
//             list.push({ "value": i });
//         }

//         return list;
//     }

//     isScdFlagDisabled(objectWrapper, tgt_Attr_Lnk) {
//         for (let j = 0; j < objectWrapper.target.tgt_Attr_Lnks.length; j++) {
//             let tgt_Attr_LnkTmp = objectWrapper.target.tgt_Attr_Lnks[j];

//             if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;
//             // || objectWrapper.isHashKeySelected
//             if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//                 tgt_Attr_Lnk.scdFlag = "N";
//                 return true;
//             }
//             return false;
//         }
//     }

//     isShowSourceAttribute(objectWrapper, tgt_Attr_Lnk) {
//         if (objectWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE && objectWrapper.target.tgt_Inst.tgtLoadType == "DEL") {
//             if (objectWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id).attrNm == "Id") {
//                 return true;
//             }
//             else {
//                 return false;
//             }
//         }
//         return true;
//     }

//     isScdDtDisabled(objectWrapper, tgt_Attr_Lnk, fromStart) {
//         let dbTyp_Id = this.getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper)

//         // if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//         //     tgt_Attr_Lnk.scdStartDtFlag = 'N';
//         //     return true;
//         // }

//         if (objectWrapper.target.tgt_Inst.scdType == "DATE") {
//             if (!DatabaseWrappersFactory.getInstance().isDateFamily(objectWrapper.dbTyp_Id, dbTyp_Id)) {
//                 return true;
//             }
//         }

//         if (objectWrapper.target.tgt_Inst.scdType == "DATE") {
//             return false;
//         }

//         if (objectWrapper.target.tgt_Inst.scdType == "KEY") {
//             if (!DatabaseWrappersFactory.getInstance().isNumberFamily(objectWrapper.dbTyp_Id, dbTyp_Id))
//                 return true;
//         }

//         return false;
//     }
//     getAttributeDbType_Id(attr_Id, targetWrapper) {
//         let attribute = targetWrapper.sub_Ids.get(attr_Id);
//         if (attribute)
//             return attribute.attrDTyp_Id;
//         return '';
//     }

//     isHashKeyFlagDisabled(objectWrapper, tgt_Attr_Lnk) {

//         for (let j = 0; j < objectWrapper.target.tgt_Attr_Lnks.length; j++) {
//             let tgt_Attr_LnkTmp = objectWrapper.target.tgt_Attr_Lnks[j];

//             if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

//             if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//                 tgt_Attr_Lnk.hashKey = "N";
//                 return true;
//             }
//             return false;
//         }

//     }

//     isCurrIndDisabled(objectWrapper, tgt_Attr_Lnk: Tgt_Attr_Lnk) {
//         let attrDTyp_Id = this.getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper);

//         // if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//         //     tgt_Attr_Lnk.currIndFlag = 'N';
//         //     return true;
//         // }

//         if (objectWrapper.dbTyp_Id == 6) {
//             if (DatabaseWrappersFactory.getInstance().isStringFamily(objectWrapper.dbTyp_Id, attrDTyp_Id)) {
//                 return false;
//             }
//         } else if (DatabaseWrappersFactory.getInstance().isNumberFamily(objectWrapper.dbTyp_Id, attrDTyp_Id)) {
//             return false;
//         }
//         return true;
//     }

//     isSurrKeyDisabled(objectWrapper, tgt_Attr_Lnk: Tgt_Attr_Lnk) {
//         // if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//         //     tgt_Attr_Lnk.surrogate_Key = 'N';
//         //     return true;
//         // }

//         let dbTyp_Id = this.getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper)
//         if (DatabaseWrappersFactory.getInstance().isNumberFamily(objectWrapper.dbTyp_Id, dbTyp_Id)) {
//             return false;
//         }

//         return true;
//     }

//     isUniKeyDisabled(objectWrapper, tgt_Attr_Lnk1) {
//         let distKeyFlagAttr_Ids = [];

//         if (objectWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE &&
//             (objectWrapper.target.tgt_Inst.tgtLoadType == "UPD" || objectWrapper.target.tgt_Inst.tgtLoadType == "DEL")) {
//             return true;
//         }

//         if (tgt_Attr_Lnk1.lnk_Obj_Attr_Id == -1) {
//             tgt_Attr_Lnk1.updKeyFlag = "N";
//             return true;
//         }

//         if (!objectWrapper.databaseWrapper.isPartition) return false;

//         for (let i = 0; i < objectWrapper.dataObjectWrapper.attributes.length; i++) {
//             let attribute = objectWrapper.dataObjectWrapper.attributes[i];

//             if (attribute.distKeyFlag != 0)
//                 distKeyFlagAttr_Ids.push(attribute.attr_Id);
//         }

//         for (let j = 0; j < objectWrapper.tgt_Attr_Lnks.length; j++) {
//             let tgt_Attr_Lnk = objectWrapper.tgt_Attr_Lnks[j];

//             if (tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk1.tgt_dObj_Inst_Attr_Id) continue;

//             if (distKeyFlagAttr_Ids.indexOf(tgt_Attr_Lnk1.tgt_dObj_Inst_Attr_Id) != -1)
//                 return true;
//             else if (tgt_Attr_Lnk1.lnk_Obj_Attr_Id == -1 || objectWrapper.isHashKeySelected) {
//                 tgt_Attr_Lnk1.updKeyFlag = "N";
//                 return true;
//             }

//             break;
//         }

//         return false;
//     }

//     verifyFamily(tgt_Attr_Lnk: Tgt_Attr_Lnk, carryForwardAttribute: any, targetWrapper: TargetWrapper): boolean {

//         let attribute = targetWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id);//DIAttributesUtil.get( tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, targetWrapper.dataObjectWrapper.attributes );
//         if (!attribute) return;

//         let dbTyp_Id1 = targetWrapper.nativeDbTyp_Id == -2 ? targetWrapper.dbTyp_Id : targetWrapper.nativeDbTyp_Id; //objectWrapper.code == "OUTPUT" ? objectWrapper.dbTyp_Id : objectWrapper.dataObjectWrapper.dbTyp_Id;
//         let attrDTyp_Id1 = attribute.attrDTyp_Id;

//         let dbTyp_Id2 = targetWrapper.nativeDbTyp_Id; //TODO
//         let attrDTyp_Id2 = carryForwardAttribute.attrDTyp_Id;

//         let allowString = true;
//         let intTolet = false;
//         let isSameFamily = DatabaseWrappersFactory.getInstance().isSameFamily(dbTyp_Id1, attrDTyp_Id1, dbTyp_Id2, attrDTyp_Id2, allowString, intTolet);

//         if (!isSameFamily)
//             return isSameFamily;

//         let dataTypeName1 = '';
//         let dataType1 = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id1, attrDTyp_Id1);
//         if (dataType1) dataTypeName1 = (dataType1.name).toLowerCase();

//         let dataTypeName2 = '';
//         let dataType2 = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id2, attrDTyp_Id2);
//         if (dataType2) dataTypeName2 = (dataType2.name).toLowerCase();

//         if (dataTypeName1 == dataTypeName2)
//             return true;

//         return false;
//     }


//     updKeyFlagChanged(tgt_Attr_Lnk, targetWrapper) {
//         if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//             tgt_Attr_Lnk.scdFlag = 'N';
//             tgt_Attr_Lnk.currIndFlag = 'N'
//             tgt_Attr_Lnk.scdStartDtFlag = 'N'
//             tgt_Attr_Lnk.scdEndDtFlag = 'N'
//             tgt_Attr_Lnk.surrogate_Key = 'N'
//         }

//         if (targetWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE && targetWrapper.target.tgt_Inst.tgtLoadType == "UPI") {

//             for (var i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
//                 if (targetWrapper.target.tgt_Attr_Lnks[i].tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;
//                 targetWrapper.target.tgt_Attr_Lnks[i].updKeyFlag = 'N';
//                 targetWrapper.validateTgt_Attr_Lnk(targetWrapper.target.tgt_Attr_Lnks[i]);

//             }
//         }

//         tgt_Attr_Lnk.update_Column = 'N';

//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }

//     insert_ColumnChanged(tgt_Attr_Lnk, targetWrapper) {
//         if (targetWrapper.target.tgt_Inst.tgtLoadType == 'UPI') {
//             tgt_Attr_Lnk.scdFlag = 'N';
//             tgt_Attr_Lnk.currIndFlag = 'N'
//             tgt_Attr_Lnk.scdStartDtFlag = 'N'
//             tgt_Attr_Lnk.scdEndDtFlag = 'N'
//             tgt_Attr_Lnk.surrogate_Key = 'N'
//         }
//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }

//     update_ColumnChanged(tgt_Attr_Lnk, targetWrapper) {
//         if (targetWrapper.target.tgt_Inst.tgtLoadType == 'UPI') {
//             tgt_Attr_Lnk.scdFlag = 'N';
//             tgt_Attr_Lnk.currIndFlag = 'N'
//             tgt_Attr_Lnk.scdStartDtFlag = 'N'
//             tgt_Attr_Lnk.scdEndDtFlag = 'N'
//             tgt_Attr_Lnk.surrogate_Key = 'N'
//             tgt_Attr_Lnk.updKeyFlag = 'N';
//         }

//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }

//     scdFlagChanged(tgt_Attr_Lnk, targetWrapper) {
//         tgt_Attr_Lnk.updKeyFlag = 'N';
//         tgt_Attr_Lnk.scdStartDtFlag = 'N';
//         tgt_Attr_Lnk.scdEndDtFlag = 'N';
//         tgt_Attr_Lnk.currIndFlag = 'N'
//         tgt_Attr_Lnk.surrogate_Key = 'N'

//         if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
//             tgt_Attr_Lnk.scdFlag = "N";
//         }

//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }

//     hashKeyChanged(tgt_Attr_Lnk, targetWrapper) {
//         if (tgt_Attr_Lnk.hashKey == 'Y') {
//             if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1 ||
//                 tgt_Attr_Lnk.lnk_Obj_Id == -1) {
//                 tgt_Attr_Lnk.hashKey = 'N';
//                 targetWrapper.isHashKeySelected = false;
//                 return;
//             }
//             for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
//                 let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];

//                 tgt_Attr_LnkTmp.updKeyFlag = 'N';
//                 tgt_Attr_LnkTmp.scdFlag = 'N';

//                 if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) {
//                     tgt_Attr_LnkTmp.hashKey = 'N';
//                 }
//             }
//             targetWrapper.target.tgt_Inst.scdDefStartDt = "";

//             targetWrapper.isHashKeySelected = true;
//         } else {
//             targetWrapper.isHashKeySelected = false;
//         }

//         targetWrapper.doValidate();
//     }

//     scdStartDtFlagChanged(tgt_Attr_Lnk, targetWrapper) {
//         if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//             tgt_Attr_Lnk.updKeyFlag = 'N';
//             tgt_Attr_Lnk.scdFlag = 'N';
//             tgt_Attr_Lnk.scdEndDtFlag = 'N';
//             tgt_Attr_Lnk.currIndFlag = 'N';
//             tgt_Attr_Lnk.surrogate_Key = 'N';
//         }

//         for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
//             let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
//             if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

//             if (tgt_Attr_LnkTmp.scdStartDtFlag != 'N') {
//                 tgt_Attr_LnkTmp.scdStartDtFlag = 'N';
//                 targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
//             }
//         }

//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }

//     scdEndDtFlagChanged(tgt_Attr_Lnk, targetWrapper) {

//         if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//             tgt_Attr_Lnk.updKeyFlag = 'N';
//             tgt_Attr_Lnk.scdFlag = 'N';
//             tgt_Attr_Lnk.scdStartDtFlag = 'N';
//             tgt_Attr_Lnk.currIndFlag = 'N';
//             tgt_Attr_Lnk.surrogate_Key = 'N';
//         }
//         for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
//             let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
//             if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

//             if (tgt_Attr_LnkTmp.scdEndDtFlag != 'N') {
//                 tgt_Attr_LnkTmp.scdEndDtFlag = 'N';
//                 targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
//             }
//         }

//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }

//     currIndFlagChanged(tgt_Attr_Lnk, targetWrapper) {
//         if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//             tgt_Attr_Lnk.updKeyFlag = 'N';
//             tgt_Attr_Lnk.surrogate_Key = 'N';
//             tgt_Attr_Lnk.scdFlag = 'N';
//             tgt_Attr_Lnk.scdStartDtFlag = 'N';
//             tgt_Attr_Lnk.scdEndDtFlag = 'N';

//             tgt_Attr_Lnk.lnk_Obj_Id = -1;
//             tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
//         }

//         for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
//             let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
//             if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

//             if (tgt_Attr_LnkTmp.currIndFlag != 'N') {
//                 tgt_Attr_LnkTmp.currIndFlag = 'N';
//                 targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
//             }
//         }

//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }

//     surrogate_KeyChanged(tgt_Attr_Lnk, targetWrapper) {
//         if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
//             tgt_Attr_Lnk.scdFlag = 'N';
//             tgt_Attr_Lnk.currIndFlag = 'N'
//             tgt_Attr_Lnk.updKeyFlag = 'N';
//             tgt_Attr_Lnk.scdStartDtFlag = 'N'
//             tgt_Attr_Lnk.scdEndDtFlag = 'N'

//             tgt_Attr_Lnk.lnk_Obj_Id = -1;
//             tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
//         }


//         for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
//             let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
//             if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

//             if (tgt_Attr_LnkTmp.surrogate_Key != 'N') {
//                 tgt_Attr_LnkTmp.surrogate_Key = 'N';
//                 targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
//             }
//         }

//         targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
//         targetWrapper.doValidate();
//     }
// }

import { AttributesUtil } from '../attributes/attributes.util';
import { ErrorCdsEnums } from 'src/app/shared/errorcds.enums';
import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';
import { Tgt_Attr_Lnk } from 'src/app/shared/models/domain/tgt_attr_lnk';
import { TargetWrapper } from '../../../modules/design/transforms/target/target.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';

export class Tgt_Attr_LnkTabulator {
    private static instance: Tgt_Attr_LnkTabulator;

    static getInstance() {
        if (!Tgt_Attr_LnkTabulator.instance) {
            Tgt_Attr_LnkTabulator.instance = new Tgt_Attr_LnkTabulator();
        }

        return Tgt_Attr_LnkTabulator.instance;
    }

    /**
    * Tgt_Attr_LnkColumns is a singleton class, so use Tgt_Attr_LnkColumns.getInstance() method instead of creating new Tgt_Attr_LnkColumns().
    */
    private constructor() {
    }

    getTgt_dObj_Inst_Attr_Id(targetWrapper: TargetWrapper): any {
        let column: any = {};

        column.title = "Target Attribute";
        column.field = 'tgt_dObj_Inst_Attr_Id';
        column.width = 200;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

            let attributeObj: any = targetWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id);
            if (!attributeObj) return '';

            return attributeObj.attrNm;
        }

        return column;
    }

    getTgtDTypNm(targetWrapper: TargetWrapper): any {
        let column: any = {};

        column.title = "Tgt Data Type";
        column.field = 'tgtDTypNm';
        column.width = 150;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

            let attributeObj: any = targetWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id);
            if (!attributeObj) return '';

            return AttributesUtil.getInstance().getAttributeType(targetWrapper.dbTyp_Id, attributeObj);
        }

        return column;
    }

    getSrcAttrNm(targetWrapper: TargetWrapper): any {
        let tgt_Attr_LnkTabulator = this;

        let column: any = {};
        column.title = "Source Attribute";
        column.field = 'srcAttrNm';
        column.width = 250;
        column.headerSort = false;

        column.formatter = function getValue(cell) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();
            if (tgt_Attr_Lnk.lnk_Obj_Id == -1 &&
                tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
                return '';
            }

            let attributeObj: any = targetWrapper.carryForwardAttributesHMapIds.get(tgt_Attr_Lnk.lnk_Obj_Id + '-' + tgt_Attr_Lnk.lnk_Obj_Attr_Id);
            if (!attributeObj) return "";

            return attributeObj.attrFullNm;
        }
        if (targetWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

            let editor: any;
            editor = document.createElement("select");
            editor.id = "mySelect";

            if (targetWrapper.carryForwardGroupAttributes.length > 0) {
                let obj_Nm: string = '';
                for (let i: number = 0; i < targetWrapper.carryForwardGroupAttributes.length; i++) {
                    let option: any = document.createElement("option");

                    if (obj_Nm != targetWrapper.carryForwardGroupAttributes[i].obj_Nm) {
                        obj_Nm = targetWrapper.carryForwardGroupAttributes[i].obj_Nm;

                        option.value = targetWrapper.carryForwardGroupAttributes[i].obj_Nm;
                        option.text = targetWrapper.carryForwardGroupAttributes[i].obj_Nm;
                        editor.appendChild(option);
                    }

                    option.value = targetWrapper.carryForwardGroupAttributes[i].obj_Id + '-' + targetWrapper.carryForwardGroupAttributes[i].attr_Id;
                    option.text = targetWrapper.carryForwardGroupAttributes[i].name;

                    editor.appendChild(option);
                }
            }

            editor.value = tgt_Attr_Lnk.lnk_Obj_Id + "-" + tgt_Attr_Lnk.lnk_Obj_Attr_Id; //cell.getValue();

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            let oldValue: string = tgt_Attr_Lnk.lnk_Obj_Id + "-" + tgt_Attr_Lnk.lnk_Obj_Attr_Id;
            function successFunc() {
                if (editor.value == "") {
                    success(editor.value);
                    return;
                }

                if (editor.value == oldValue) {
                    success(editor.value);
                    return;
                }

                let obj_Attr_Ids: Array<any> = editor.value.split('-');

                tgt_Attr_Lnk.lnk_Obj_Id = parseInt(obj_Attr_Ids[0]);
                tgt_Attr_Lnk.lnk_Obj_Attr_Id = parseInt(obj_Attr_Ids[1]);

                for (let i: number = 0; i < targetWrapper.carryForwardGroupAttributes.length; i++) {
                    let carryForwardGroupAttribute: any = targetWrapper.carryForwardGroupAttributes[i];
                    if (carryForwardGroupAttribute.obj_Id == tgt_Attr_Lnk.lnk_Obj_Id &&
                        carryForwardGroupAttribute.attr_Id == tgt_Attr_Lnk.lnk_Obj_Attr_Id) {
                        tgt_Attr_Lnk.valid_Cd = tgt_Attr_LnkTabulator.verifyFamily(tgt_Attr_Lnk, carryForwardGroupAttribute, targetWrapper) ? "0" : "-1";

                        break;
                    }
                }

                targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
                tgt_Attr_Lnk.currIndFlag = CommonEnums.flag.NO;
                tgt_Attr_Lnk.surrogate_Key = CommonEnums.flag.NO;

                targetWrapper.doValidate();

                setTimeout(() => {
                    cell.getRow().reformat();
                });

                success(editor.value);
            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);
            return editor;
        }

        return column;
    }

    getSrcDTypNm(targetWrapper: TargetWrapper): any {
        let column: any = {};
        column.title = "Src Data Type";
        column.field = "srcDTypNm";
        column.width = 150;
        column.headerSort = false;

        column.formatter = function getValue(cell) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();

            if (tgt_Attr_Lnk.lnk_Obj_Id == -1 &&
                tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
                return '';
            }

            let attributeObj: any = targetWrapper.carryForwardAttributesHMapIds.get(tgt_Attr_Lnk.lnk_Obj_Id + '-' + tgt_Attr_Lnk.lnk_Obj_Attr_Id);
            if (!attributeObj) return "";

            return attributeObj.attrDTypNm;
        }

        return column;
    }

    getValid_Cd(targetWrapper: TargetWrapper): any {
        let column: any = {};
        column.title = "Status";
        column.field = 'valid_Cd';
        column.width = 20;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            if (cell.getValue() == "0") {
                return '';
            }

            return "<i " + ErrorCdsEnums.errorcds[cell.getValue()] + "' class='text-warning fs-9 fa fa-circle hand'></i>";
        }

        return column;
    }

    getOrderBy(targetWrapper: TargetWrapper): any {
        let orderByColumn = this;

        let column: any = {};
        column.field = "orderBy";
        column.title = "Order";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function getValue(cell) {
            let tgt_Attr_Lnk: Tgt_Attr_Lnk = cell.getData();
            if (tgt_Attr_Lnk.orderBy == 0) return "";

            return tgt_Attr_Lnk.orderBy;
        };
        if (targetWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        column.editor = function (cell, onRendered, success, cancel, editorParams) {
            let value = cell.getValue();
            this.dropdownlist = orderByColumn.getAttributesLengthList((targetWrapper as TargetWrapper).target.tgt_Attr_Lnks);

            let editor;
            if (this.dropdownlist.length > 0) {
                editor = document.createElement("select");
                editor.id = "mySelect";

                for (let i: number = 0; i < this.dropdownlist.length; i++) {
                    let option = document.createElement("option");
                    option.value = this.dropdownlist[i].value;
                    option.text = this.dropdownlist[i].value;
                    editor.appendChild(option);
                }

                editor.value = value;
            }

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                editor.value = value;
                targetWrapper.doValidate();

                success(editor.value);
            }

            editor.addEventListener("change", successFunc);
            editor.addEventListener("blur", successFunc);

            return editor;
        }

        return column;
    }

    getUpdKeyFlag(targetWrapper: TargetWrapper): any {
        let updKeyFlagComponet = this;

        let column: any = {};
        column.field = "updKeyFlag";
        column.title = "Unique";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem: any = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "updKeyFlag" + dataItem.tgt_dObj_Inst_Attr_Id;
            editor.checked = dataItem.updKeyFlag == 'Y' ? true : false;

            editor.onclick = function (event: any) {
                dataItem.updKeyFlag = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;

                let rows: Array<any> = cell.getTable().getRows();
                if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
                    dataItem.scdFlag = 'N';
                    dataItem.currIndFlag = 'N'
                    dataItem.scdStartDtFlag = 'N'
                    dataItem.scdEndDtFlag = 'N'
                    dataItem.surrogate_Key = 'N'
                }

                if (targetWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE &&
                    targetWrapper.target.tgt_Inst.tgtLoadType == 'UPI') {
                    for (let i: number = 0; i < rows.length; i++) {
                        let tgt_attr_lnkTmp: Tgt_Attr_Lnk = rows[i]._row.data;
                        if (tgt_attr_lnkTmp.tgt_dObj_Inst_Attr_Id == dataItem.tgt_dObj_Inst_Attr_Id) continue;

                        if (tgt_attr_lnkTmp.updKeyFlag == CommonEnums.flag.YES) {
                            tgt_attr_lnkTmp.updKeyFlag = CommonEnums.flag.NO;
                            targetWrapper.validateTgt_Attr_Lnk(tgt_attr_lnkTmp);
                            rows[i].reformat();
                        }
                    }
                }

                dataItem.update_Column = 'N';
                targetWrapper.validateTgt_Attr_Lnk(dataItem);
                targetWrapper.doValidate();
                cell.getRow().reformat();
            }
            //disable functionlaity TODO
            if (updKeyFlagComponet.isUniKeyDisabled(targetWrapper, dataItem)) {
                editor.setAttribute("disabled", "true");
            }
            return editor;
        }

        return column;
    }

    getScdFlag(targetWrapper: TargetWrapper): any {
        let scdFlagCompent = this;

        let column: any = {};
        column.field = "scdFlag";
        column.title = "SCD key";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem: any = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "scdFlag" + dataItem.scdFlag;
            editor.checked = dataItem.scdFlag == 'Y' ? true : false;
            editor.onclick = function (event: any) {
                dataItem.scdFlag = event.target.checked ? 'Y' : 'N';
                dataItem.updKeyFlag = 'N';
                dataItem.scdStartDtFlag = 'N';
                dataItem.scdEndDtFlag = 'N';
                dataItem.currIndFlag = 'N'
                dataItem.surrogate_Key = 'N'

                if (dataItem.lnk_Obj_Attr_Id == -1) {
                    dataItem.scdFlag = "N";
                }
                cell.getRow().reformat();
                targetWrapper.validateTgt_Attr_Lnk(dataItem);
                targetWrapper.doValidate();

            }
            //disable functionlaity
            if (scdFlagCompent.isScdFlagDisabled(targetWrapper, dataItem)) {
                editor.setAttribute("disabled", "true");
            }
            return editor;
        }

        return column;
    }

    getHashKey(targetWrapper: TargetWrapper): any {
        let hashFlagComponent = this;

        let column: any = {};
        column.field = "hashKey";
        column.title = "Hash key";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem: any = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "hashKey" + dataItem.hashKey;
            editor.checked = dataItem.scdFlag == 'Y' ? true : false;
            editor.onclick = function (event: any) {
                dataItem.hashKey = event.target.checked ? 'Y' : 'N';
                hashFlagComponent.hashKeyChanged(dataItem, targetWrapper)
            }
            //disable functionlaity
            if (hashFlagComponent.isHashKeyFlagDisabled(targetWrapper, dataItem)) {
                editor.setAttribute("disabled", "true");
            }

            return editor;
        }

        return column;
    }

    getScdStartDtFlag(targetWrapper: TargetWrapper): any {
        let scdStartDtFlagComponent = this;

        let column: any = {};
        column.field = "scdStartDtFlag";
        column.title = "SCD Start";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem: any = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "scdStartDtFlag" + dataItem.scdStartDtFlag;
            editor.checked = dataItem.scdStartDtFlag == 'Y' ? true : false;
            let rows: Array<any> = cell.getTable().getRows();

            editor.onclick = function (event: any) {
                dataItem.scdStartDtFlag = event.target.checked ? 'Y' : 'N';
                // scdStartDtFlagComponent.scdStartDtFlagChanged(dataItem, targetWrapper)

                if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
                    dataItem.updKeyFlag = 'N';
                    dataItem.scdFlag = 'N';
                    dataItem.scdEndDtFlag = 'N';
                    dataItem.currIndFlag = 'N';
                    dataItem.surrogate_Key = 'N';
                }

                for (let i = 0; i < rows.length; i++) {
                    let tgt_Attr_LnkTmp = rows[i]._row.data;
                    if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == dataItem.tgt_dObj_Inst_Attr_Id) continue;

                    if (tgt_Attr_LnkTmp.scdStartDtFlag != 'N') {
                        tgt_Attr_LnkTmp.scdStartDtFlag = 'N';
                        rows[i].reformat();
                        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
                    }
                }
                cell.getRow().reformat();
                targetWrapper.validateTgt_Attr_Lnk(dataItem);
                targetWrapper.doValidate();

            }
            //disable functionlaity TO DO
            if (scdStartDtFlagComponent.isScdDtDisabled(targetWrapper, dataItem, true)) {
                editor.setAttribute("disabled", "true");
            }

            return editor;
        }

        return column;
    }

    getScdEndDtFlag(targetWrapper: TargetWrapper): any {
        let scdEndcomponent = this;

        let column: any = {};
        column.field = "scdEndDtFlag";
        column.title = "SCD End";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "scdEndDtFlag" + dataItem.scdEndDtFlag;
            editor.checked = dataItem.scdEndDtFlag == 'Y' ? true : false;
            editor.onclick = function (event: any) {
                dataItem.scdEndDtFlag = event.target.checked ? 'Y' : 'N';
                //scdEndcomponent.scdEndDtFlagChanged(dataItem, targetWrapper)
                let rows: Array<any> = cell.getTable().getRows();
                if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
                    dataItem.updKeyFlag = 'N';
                    dataItem.scdFlag = 'N';
                    dataItem.scdStartDtFlag = 'N';
                    dataItem.currIndFlag = 'N';
                    dataItem.surrogate_Key = 'N';
                }
                for (let i = 0; i < rows.length; i++) {
                    let tgt_Attr_LnkTmp = rows[i]._row.data;
                    if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == dataItem.tgt_dObj_Inst_Attr_Id) continue;

                    if (tgt_Attr_LnkTmp.scdEndDtFlag != 'N') {
                        tgt_Attr_LnkTmp.scdEndDtFlag = 'N';
                        rows[i].reformat();
                        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
                    }
                }
                cell.getRow().reformat();
                targetWrapper.validateTgt_Attr_Lnk(dataItem);
                targetWrapper.doValidate();

            }

            if (scdEndcomponent.isScdDtDisabled(targetWrapper, dataItem, false)) {
                editor.setAttribute("disabled", "true");
            }

            return editor;
        }

        return column;
    }

    getCurrIndFlag(targetWrapper: TargetWrapper): any {
        let currIndFlagComponnet = this;

        let column: any = {};
        column.field = "currIndFlag";
        column.title = "Current Ind";
        column.width = 100;
        column.sortable = false;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "currIndFlag" + dataItem.currIndFlag;
            editor.checked = dataItem.currIndFlag == 'Y' ? true : false;
            editor.onclick = function (event: any) {
                dataItem.currIndFlag = event.target.checked ? 'Y' : 'N';
                currIndFlagComponnet.currIndFlagChanged(dataItem, targetWrapper);
                cell.getRow().reformat();
            }
            //disable functionlaity TO DO
            if (currIndFlagComponnet.isCurrIndDisabled(targetWrapper, dataItem)) {
                editor.setAttribute("disabled", "true");
            }

            return editor;
        }

        return column;
    }

    getSurrogate_Key(targetWrapper: TargetWrapper): any {
        let surrogate_KeyComponent = this;

        let column: any = {};
        column.field = "surrogate_Key";
        column.title = "Surrogate Key.";
        column.width = 100;
        column.sortable = false;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem: any = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "surrogate_Key" + dataItem.surrogate_Key;
            editor.checked = dataItem.surrogate_Key == 'Y' ? true : false;
            editor.onclick = function (event: any) {
                dataItem.surrogate_Key = event.target.checked ? 'Y' : 'N';
                surrogate_KeyComponent.surrogate_KeyChanged(dataItem, targetWrapper)
            }
            //disable functionlaity TO DO
            if (surrogate_KeyComponent.isSurrKeyDisabled(targetWrapper, dataItem)) {
                editor.setAttribute("disabled", "true");
            }

            return editor;
        }

        return column;
    }

    getInsert_Column(targetWrapper: TargetWrapper): any {
        let insert_ColumnComponnet = this;

        let column: any = {};
        column.field = "insert_Column";
        column.title = "Insert";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "insert_Column" + dataItem.insert_Column;
            editor.checked = dataItem.insert_Column == 'Y' ? true : false;
            editor.onclick = function (event: any) {
                dataItem.insert_Column = event.target.checked ? 'Y' : 'N';
                insert_ColumnComponnet.insert_ColumnChanged(dataItem, targetWrapper);
            }
            //disable functionlaity TO DO
            if (insert_ColumnComponnet.isUniKeyDisabled(targetWrapper, dataItem)) {
                editor.setAttribute("disabled", "true");
            }

            return editor;
        }

        return column;
    }

    getUpdate_Column(targetWrapper: TargetWrapper): any {
        let update_ColumnComponnet = this;

        let column: any = {};
        column.field = "update_Column";
        column.title = "Update";
        column.width = 100;
        column.headerSort = false;

        column.formatter = function (cell, formatterParams, onRendered) {
            let dataItem = cell.getData();
            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.id = "update_Column" + dataItem.update_Column;
            editor.checked = dataItem.update_Column == 'Y' ? true : false;
            editor.onclick = function (event: any) {
                dataItem.update_Column = event.target.checked ? 'Y' : 'N';
                update_ColumnComponnet.update_ColumnChanged(dataItem, targetWrapper);
                cell.getRow().reformat();
            }
            if (update_ColumnComponnet.isUniKeyDisabled(targetWrapper, dataItem)) {
                editor.setAttribute("disabled", "true");
            }

            return editor;
        }

        return column;
    }

    getAttributesLengthList(attributes: Array<any>): Array<any> {
        let list: Array<any> = new Array<any>();

        for (let i = 0; i <= attributes.length; i++) {
            list.push({ "value": i });
        }

        return list;
    }

    isScdFlagDisabled(objectWrapper, tgt_Attr_Lnk) {
        for (let j = 0; j < objectWrapper.target.tgt_Attr_Lnks.length; j++) {
            let tgt_Attr_LnkTmp = objectWrapper.target.tgt_Attr_Lnks[j];

            if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;
            // || objectWrapper.isHashKeySelected
            if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
                tgt_Attr_Lnk.scdFlag = "N";
                return true;
            }
            return false;
        }
    }

    isShowSourceAttribute(objectWrapper, tgt_Attr_Lnk) {
        if (objectWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE && objectWrapper.target.tgt_Inst.tgtLoadType == "DEL") {
            if (objectWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id).attrNm == "Id") {
                return true;
            }
            else {
                return false;
            }
        }
        return true;
    }

    isScdDtDisabled(objectWrapper, tgt_Attr_Lnk, fromStart) {
        let dbTyp_Id = this.getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper)

        // if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
        //     tgt_Attr_Lnk.scdStartDtFlag = 'N';
        //     return true;
        // }

        if (objectWrapper.target.tgt_Inst.scdType == "DATE") {
            if (!DatabaseWrappersFactory.getInstance().isDateFamily(objectWrapper.dbTyp_Id, dbTyp_Id)) {
                return true;
            }
        }

        if (objectWrapper.target.tgt_Inst.scdType == "DATE") {
            return false;
        }

        if (objectWrapper.target.tgt_Inst.scdType == "KEY") {
            if (!DatabaseWrappersFactory.getInstance().isNumberFamily(objectWrapper.dbTyp_Id, dbTyp_Id))
                return true;
        }

        return false;
    }
    getAttributeDbType_Id(attr_Id, targetWrapper) {
        let attribute = targetWrapper.sub_Ids.get(attr_Id);
        if (attribute)
            return attribute.attrDTyp_Id;
        return '';
    }

    isHashKeyFlagDisabled(objectWrapper, tgt_Attr_Lnk) {

        for (let j = 0; j < objectWrapper.target.tgt_Attr_Lnks.length; j++) {
            let tgt_Attr_LnkTmp = objectWrapper.target.tgt_Attr_Lnks[j];

            if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

            if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
                tgt_Attr_Lnk.hashKey = "N";
                return true;
            }
            return false;
        }

    }

    isCurrIndDisabled(objectWrapper, tgt_Attr_Lnk: Tgt_Attr_Lnk) {
        let attrDTyp_Id = this.getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper);

        // if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
        //     tgt_Attr_Lnk.currIndFlag = 'N';
        //     return true;
        // }

        if (objectWrapper.dbTyp_Id == 6) {
            if (DatabaseWrappersFactory.getInstance().isStringFamily(objectWrapper.dbTyp_Id, attrDTyp_Id)) {
                return false;
            }
        } else if (DatabaseWrappersFactory.getInstance().isNumberFamily(objectWrapper.dbTyp_Id, attrDTyp_Id)) {
            return false;
        }
        return true;
    }

    isSurrKeyDisabled(objectWrapper, tgt_Attr_Lnk: Tgt_Attr_Lnk) {
        // if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
        //     tgt_Attr_Lnk.surrogate_Key = 'N';
        //     return true;
        // }

        let dbTyp_Id = this.getAttributeDbType_Id(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, objectWrapper)
        if (DatabaseWrappersFactory.getInstance().isNumberFamily(objectWrapper.dbTyp_Id, dbTyp_Id)) {
            return false;
        }

        return true;
    }

    isUniKeyDisabled(objectWrapper, tgt_Attr_Lnk1) {
        let distKeyFlagAttr_Ids = [];

        if (objectWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE &&
            (objectWrapper.target.tgt_Inst.tgtLoadType == "UPD" || objectWrapper.target.tgt_Inst.tgtLoadType == "DEL")) {
            return true;
        }

        if (tgt_Attr_Lnk1.lnk_Obj_Attr_Id == -1) {
            tgt_Attr_Lnk1.updKeyFlag = "N";
            return true;
        }

        if (!objectWrapper.databaseWrapper.isPartition) return false;

        for (let i = 0; i < objectWrapper.dataObjectWrapper.attributes.length; i++) {
            let attribute = objectWrapper.dataObjectWrapper.attributes[i];

            if (attribute.distKeyFlag != 0)
                distKeyFlagAttr_Ids.push(attribute.attr_Id);
        }

        for (let j = 0; j < objectWrapper.tgt_Attr_Lnks.length; j++) {
            let tgt_Attr_Lnk = objectWrapper.tgt_Attr_Lnks[j];

            if (tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk1.tgt_dObj_Inst_Attr_Id) continue;

            if (distKeyFlagAttr_Ids.indexOf(tgt_Attr_Lnk1.tgt_dObj_Inst_Attr_Id) != -1)
                return true;
            else if (tgt_Attr_Lnk1.lnk_Obj_Attr_Id == -1 || objectWrapper.isHashKeySelected) {
                tgt_Attr_Lnk1.updKeyFlag = "N";
                return true;
            }

            break;
        }

        return false;
    }

    verifyFamily(tgt_Attr_Lnk: Tgt_Attr_Lnk, carryForwardAttribute: any, targetWrapper: TargetWrapper): boolean {

        let attribute = targetWrapper.sub_Ids.get(tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id);//DIAttributesUtil.get( tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id, targetWrapper.dataObjectWrapper.attributes );
        if (!attribute) return;

        let dbTyp_Id1 = targetWrapper.nativeDbTyp_Id == -2 ? targetWrapper.dbTyp_Id : targetWrapper.nativeDbTyp_Id; //objectWrapper.code == "OUTPUT" ? objectWrapper.dbTyp_Id : objectWrapper.dataObjectWrapper.dbTyp_Id;
        let attrDTyp_Id1 = attribute.attrDTyp_Id;

        let dbTyp_Id2 = targetWrapper.nativeDbTyp_Id; //TODO
        let attrDTyp_Id2 = carryForwardAttribute.attrDTyp_Id;

        let allowString = true;
        let intTolet = false;
        let isSameFamily = DatabaseWrappersFactory.getInstance().isSameFamily(dbTyp_Id1, attrDTyp_Id1, dbTyp_Id2, attrDTyp_Id2, allowString, intTolet);

        if (!isSameFamily)
            return isSameFamily;

        let dataTypeName1 = '';
        let dataType1 = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id1, attrDTyp_Id1);
        if (dataType1) dataTypeName1 = (dataType1.name).toLowerCase();

        let dataTypeName2 = '';
        let dataType2 = DatabaseWrappersFactory.getInstance().getDatatype(dbTyp_Id2, attrDTyp_Id2);
        if (dataType2) dataTypeName2 = (dataType2.name).toLowerCase();

        if (dataTypeName1 == dataTypeName2)
            return true;

        return false;
    }


    updKeyFlagChanged(tgt_Attr_Lnk, targetWrapper) {
        if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
            tgt_Attr_Lnk.scdFlag = 'N';
            tgt_Attr_Lnk.currIndFlag = 'N'
            tgt_Attr_Lnk.scdStartDtFlag = 'N'
            tgt_Attr_Lnk.scdEndDtFlag = 'N'
            tgt_Attr_Lnk.surrogate_Key = 'N'
        }

        if (targetWrapper.dbTyp_Id == DatabaseEnum.databaseId.SALESFORCE && targetWrapper.target.tgt_Inst.tgtLoadType == "UPI") {

            for (var i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
                if (targetWrapper.target.tgt_Attr_Lnks[i].tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;
                targetWrapper.target.tgt_Attr_Lnks[i].updKeyFlag = 'N';
                targetWrapper.validateTgt_Attr_Lnk(targetWrapper.target.tgt_Attr_Lnks[i]);

            }
        }

        tgt_Attr_Lnk.update_Column = 'N';

        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }

    insert_ColumnChanged(tgt_Attr_Lnk, targetWrapper) {
        if (targetWrapper.target.tgt_Inst.tgtLoadType == 'UPI') {
            tgt_Attr_Lnk.scdFlag = 'N';
            tgt_Attr_Lnk.currIndFlag = 'N'
            tgt_Attr_Lnk.scdStartDtFlag = 'N'
            tgt_Attr_Lnk.scdEndDtFlag = 'N'
            tgt_Attr_Lnk.surrogate_Key = 'N'
        }
        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }

    update_ColumnChanged(tgt_Attr_Lnk, targetWrapper) {
        if (targetWrapper.target.tgt_Inst.tgtLoadType == 'UPI') {
            tgt_Attr_Lnk.scdFlag = 'N';
            tgt_Attr_Lnk.currIndFlag = 'N'
            tgt_Attr_Lnk.scdStartDtFlag = 'N'
            tgt_Attr_Lnk.scdEndDtFlag = 'N'
            tgt_Attr_Lnk.surrogate_Key = 'N'
            tgt_Attr_Lnk.updKeyFlag = 'N';
        }

        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }

    scdFlagChanged(tgt_Attr_Lnk, targetWrapper) {
        tgt_Attr_Lnk.updKeyFlag = 'N';
        tgt_Attr_Lnk.scdStartDtFlag = 'N';
        tgt_Attr_Lnk.scdEndDtFlag = 'N';
        tgt_Attr_Lnk.currIndFlag = 'N'
        tgt_Attr_Lnk.surrogate_Key = 'N'

        if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1) {
            tgt_Attr_Lnk.scdFlag = "N";
        }

        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }

    hashKeyChanged(tgt_Attr_Lnk, targetWrapper) {
        if (tgt_Attr_Lnk.hashKey == 'Y') {
            if (tgt_Attr_Lnk.lnk_Obj_Attr_Id == -1 ||
                tgt_Attr_Lnk.lnk_Obj_Id == -1) {
                tgt_Attr_Lnk.hashKey = 'N';
                targetWrapper.isHashKeySelected = false;
                return;
            }
            for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
                let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];

                tgt_Attr_LnkTmp.updKeyFlag = 'N';
                tgt_Attr_LnkTmp.scdFlag = 'N';

                if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id != tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) {
                    tgt_Attr_LnkTmp.hashKey = 'N';
                }
            }
            targetWrapper.target.tgt_Inst.scdDefStartDt = "";

            targetWrapper.isHashKeySelected = true;
        } else {
            targetWrapper.isHashKeySelected = false;
        }

        targetWrapper.doValidate();
    }

    scdStartDtFlagChanged(tgt_Attr_Lnk, targetWrapper) {
        if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
            tgt_Attr_Lnk.updKeyFlag = 'N';
            tgt_Attr_Lnk.scdFlag = 'N';
            tgt_Attr_Lnk.scdEndDtFlag = 'N';
            tgt_Attr_Lnk.currIndFlag = 'N';
            tgt_Attr_Lnk.surrogate_Key = 'N';
        }

        for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
            let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
            if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

            if (tgt_Attr_LnkTmp.scdStartDtFlag != 'N') {
                tgt_Attr_LnkTmp.scdStartDtFlag = 'N';
                targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
            }
        }

        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }

    scdEndDtFlagChanged(tgt_Attr_Lnk, targetWrapper) {

        if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
            tgt_Attr_Lnk.updKeyFlag = 'N';
            tgt_Attr_Lnk.scdFlag = 'N';
            tgt_Attr_Lnk.scdStartDtFlag = 'N';
            tgt_Attr_Lnk.currIndFlag = 'N';
            tgt_Attr_Lnk.surrogate_Key = 'N';
        }
        for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
            let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
            if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

            if (tgt_Attr_LnkTmp.scdEndDtFlag != 'N') {
                tgt_Attr_LnkTmp.scdEndDtFlag = 'N';
                targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
            }
        }

        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }

    currIndFlagChanged(tgt_Attr_Lnk, targetWrapper) {
        if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
            tgt_Attr_Lnk.updKeyFlag = 'N';
            tgt_Attr_Lnk.surrogate_Key = 'N';
            tgt_Attr_Lnk.scdFlag = 'N';
            tgt_Attr_Lnk.scdStartDtFlag = 'N';
            tgt_Attr_Lnk.scdEndDtFlag = 'N';

            tgt_Attr_Lnk.lnk_Obj_Id = -1;
            tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
        }

        for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
            let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
            if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

            if (tgt_Attr_LnkTmp.currIndFlag != 'N') {
                tgt_Attr_LnkTmp.currIndFlag = 'N';
                targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
            }
        }

        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }

    surrogate_KeyChanged(tgt_Attr_Lnk, targetWrapper) {
        if (targetWrapper.target.tgt_Inst.tgtLoadType == 'SCD') {
            tgt_Attr_Lnk.scdFlag = 'N';
            tgt_Attr_Lnk.currIndFlag = 'N'
            tgt_Attr_Lnk.updKeyFlag = 'N';
            tgt_Attr_Lnk.scdStartDtFlag = 'N'
            tgt_Attr_Lnk.scdEndDtFlag = 'N'

            tgt_Attr_Lnk.lnk_Obj_Id = -1;
            tgt_Attr_Lnk.lnk_Obj_Attr_Id = -1;
        }


        for (let i = 0; i < targetWrapper.target.tgt_Attr_Lnks.length; i++) {
            let tgt_Attr_LnkTmp = targetWrapper.target.tgt_Attr_Lnks[i];
            if (tgt_Attr_LnkTmp.tgt_dObj_Inst_Attr_Id == tgt_Attr_Lnk.tgt_dObj_Inst_Attr_Id) continue;

            if (tgt_Attr_LnkTmp.surrogate_Key != 'N') {
                tgt_Attr_LnkTmp.surrogate_Key = 'N';
                targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_LnkTmp);
            }
        }

        targetWrapper.validateTgt_Attr_Lnk(tgt_Attr_Lnk);
        targetWrapper.doValidate();
    }
}
